import React from "react";

import css from "./notFound.module.css";
import { Link } from "react-router-dom";
import Header from "../standartComponents/header";

const NotFound = ({ authUser }) => {
  return (
    <>
      <div className={css.containerHeader}>
        <Header authUser={authUser} />
        <div className={css.wrapFour}>
          <h1 className={css.h1Fo}>404</h1>
          <p className={css.pFor}>Sorry, but this page does not exist.</p>
          <Link className={css.relocateTo} to="/">
            Back to Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
